import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68eb2878"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "show-connections",
  class: "list-page d-flex flex-fill"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id", "onClick"]
const _hoisted_5 = { class: "d-flex align-items-center justify-content-start min-max-width-116" }
const _hoisted_6 = { class: "img-box-white d-flex align-items-center justify-content-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "btn-label" }
const _hoisted_12 = { class: "btn-text" }
const _hoisted_13 = { class: "col d-flex flex-row align-items-center justify-content-center" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_16 = {
  key: 0,
  class: "loader-25 margin-left-3"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "pagination-wrapper mt-1" }
const _hoisted_19 = { class: "loader-div-40" }
const _hoisted_20 = ["src"]

import { onMounted, ref } from "vue";
import {
  ElButton,
  ElCard,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElInput,
  ElTable,
  ElTableColumn,
  ElTag,
  ElSwitch,
  ElDivider,
} from "element-plus";
import { cloneDeep } from "lodash-es";
import { TYPE } from "vue-toastification";
import { showAlert, showConfirm } from "@/core/popup";
import {
  deleteConnection,
  getConnectionListing,
  inLineEditConnection,
  checkIfConnectionUsedInFlows,
} from "@/connection/services/connection.service";
import { router } from "@/core/router";
import {
  hasPermission,
  updateMultiplePreference,
  updateSinglePreference,
} from "@/core/auth";
import i18n from "@/core/i18n/i18n";
import { ASSETS_BASE_URL, DEFAULT_LOGO, getResolution } from "@/core/logo";
import { getPreferenceValue } from "@/core/preferences/preferences";
import { useDebouncedSearch } from "@/core/composables/useDebouncedSearch";
import { useLatestRequestGuard } from "@/core/composables/useLatestRequestGuard";
import OneTegPagination from "@/common/components/OneTegPagination.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Connections',
  setup(__props) {

const { t } = i18n.global;
const connectionList = ref([]);
const loadingConnections = ref(false);
const connectionsRequestGuard = useLatestRequestGuard();
const search = ref("");
const sortField = ref(
  getPreferenceValue("connectionsSortField")
    ? getPreferenceValue("connectionsSortField")
    : "createdAt"
);
const sortAscending = ref(
  getPreferenceValue("connectionsSortOrder")
    ? getPreferenceValue("connectionsSortOrder")
    : "ascending"
);

const perPageConnections = ref(
  getPreferenceValue("pageSize") ? getPreferenceValue("pageSize") : 10
);

const currentPageConnections = ref(1);

const hoverId = ref("");
const animate = ref(false);

const editMode = ref(false);

const headerStyle = ref({
  color: "#363636",
  borderBottomColor: "#a9d4fa",
  fontSize: "15px",
  fontWeight: "bolder !important",
  backgroundColor: "#fbfbfb",
});

const newObject = ref({
  id: undefined,
  name: undefined,
  hostName: undefined,
  active: undefined,
});

const rowStyle = ref({
  cursor: "pointer",
  backgroundColor: "#fbfbfb",
});

function cellMouseEnter(row) {
  hoverId.value = row.id;
}

function cellMouseLeave() {
  hoverId.value = "";
}

const numberOfConnections = ref(0);

function goToEditPage(row) {
  if (hasPermission("CONNECTIONS.LIST.EDIT") && newObject.value.id !== row.id) {
    router.push(`/connections/edit/${row.id}`);
  } else if (newObject.value.id === row.id) {
    animate.value = true;
    setTimeout(() => {
      animate.value = false;
    }, 2200);
  }
}

function sizeChanged(val) {
  perPageConnections.value = val;
  updateSinglePreference("pageSize", val);
  getConnections();
}

function openEditMode(row) {
  animate.value = false;
  if (
    newObject.value.id !== row.id &&
    hasPermission("CONNECTIONS.LIST.INLINE.EDIT")
  ) {
    newObject.value = cloneDeep(row);
    editMode.value = true;
  }
}

const { onSearchInput } = useDebouncedSearch(getConnections);

function sortChanged(sort) {
  sortField.value = sort.prop;
  sortAscending.value = sort.order;
  updateMultiplePreference({
    connectionsSortField: sort.prop,
    connectionsSortOrder: sort.order,
  });
  getConnections();
}

function closeEditMode() {
  editMode.value = false;
  newObject.value = {
    id: undefined,
    name: undefined,
    hostName: undefined,
    active: undefined,
  };
}

async function changeActiveStatus(row) {
  let isConfirmed = true;
  row.loading = true;
  if (!row.active && hasPermission("CONNECTIONS.LIST.INLINE.CHANGE_ACTIVE")) {
    const isUsing = await checkIfConnectionUsedInFlows(row.id);
    if (isUsing.error) {
      showAlert(TYPE.ERROR, t("Connection.ErrorOccurred"));
      row.loading = false;
      return;
    }
    if (isUsing.result.length > 0) {
      isConfirmed = await showConfirm(
        "warning",
        t("Connection.ConnectionDeactivationConfirmation"),
        t("Connection.DeactivateConfirmationMsg", { connectionName: row.name })
      );
    }
  }
  if (isConfirmed && hasPermission("CONNECTIONS.LIST.INLINE.CHANGE_ACTIVE")) {
    const result = await lineEditConnection(row);
    if (result) {
      showAlert(
        row.active ? TYPE.SUCCESS : TYPE.WARNING,
        t(
          row.active
            ? "Connection.ConnectionActivated"
            : "Connection.ConnectionDeActivated"
        )
      );
    }
  }
  row.loading = false;
}

async function editSelectedConnection() {
  if (
    editMode.value &&
    newObject.value.name &&
    hasPermission("CONNECTIONS.LIST.INLINE.EDIT")
  ) {
    const result = await lineEditConnection(newObject.value);
    if (result) {
      editMode.value = false;
      newObject.value = {
        id: undefined,
        name: undefined,
        hostName: undefined,
        active: undefined,
      };
      await getConnections();
      showAlert(TYPE.SUCCESS, t("Connection.ConnectionSaved"));
    }
  } else {
    showAlert(TYPE.WARNING, t("Common.WarningName"));
  }
}

async function lineEditConnection(connection) {
  let result = false;
  await inLineEditConnection(connection.id, connection).then(
    async (response) => {
      if (response) {
        result = true;
      }
    }
  );
  return result;
}

onMounted(() => {
  getConnections();
});

function convertDate(dateStr) {
  const milliseconds = Date.parse(dateStr);
  const date = new Date(milliseconds);
  return date.toLocaleDateString();
}

async function getConnections() {
  const requestToken = connectionsRequestGuard.start();
  loadingConnections.value = true;
  const params = {
    pageNumber: currentPageConnections.value - 1,
    pageSize: perPageConnections.value,
    sortField: sortField.value,
    ascending: sortAscending.value === "ascending",
    search: search.value,
  };
  try {
    const page = await getConnectionListing(params);
    // OT-4928: discard a stale response superseded by a newer search/request.
    if (!connectionsRequestGuard.isLatest(requestToken)) {
      return;
    }
    connectionList.value = page.data;
    numberOfConnections.value = page.totalElements;
  } finally {
    // OT-4928: only the newest request owns the spinner — a superseded one must
    // not clear it, and a newest one that fails must not leave it stuck on.
    if (connectionsRequestGuard.isLatest(requestToken)) {
      loadingConnections.value = false;
    }
  }
}

async function removeConnection(connection) {
  const isConfirmed: boolean = await showConfirm(
    "warning",
    t("Connection.DeleteConnection"),
    t("Connection.DeleteMsg", { name: connection.name })
  );

  if (isConfirmed) {
    connection.loading = true;
    const result = await deleteConnection(connection.id);
    connection.loading = false;

    if (result.code === 200) {
      await getConnections();
      showAlert(
        TYPE.SUCCESS,
        t("Connection.ConnectionDeletedWithName", { name: connection.name })
      );
    } else if (
      result.code === 409 &&
      result.result &&
      result.result.length > 0
    ) {
      const flowCount = result.result.length;
      const flows = result.result.map((flow) => `• ${flow}`).join("<br>");
      const flowsToShow = `<br>${flows}<br>`;

      const confirmMessage =
        flowCount === 1
          ? t("Connection.ConnectionIsBeingUsedInSingleFlow", {
              flow: flowsToShow,
            })
          : t("Connection.ConnectionIsBeingUsedInMultipleFlows", {
              flowsToShow,
            });

      await showConfirm(
        "warning",
        t("Connection.DeleteConnection"),
        confirmMessage
      );
    } else {
      showAlert(
        TYPE.ERROR,
        t("Connection.DeletionError", { name: connection.name })
      );
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElCard), { class: "card border-0 oneTeg-card oneTeg-card-body" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElTable), {
          data: connectionList.value,
          "default-sort": { prop: sortField.value, order: sortAscending.value },
          "empty-text": loadingConnections.value ? ' ' : 'No Data',
          onRowClick: goToEditPage,
          onCellMouseEnter: cellMouseEnter,
          onCellMouseLeave: cellMouseLeave,
          onSortChange: sortChanged,
          "row-class-name": 
          _unref(hasPermission)('CONNECTIONS.LIST.EDIT')
            ? 'oneTeg-table-row-permission'
            : 'oneTeg-table-row-no-permission'
        ,
          class: "oneTeg-table",
          height: "97%"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Connection'),
              prop: "name",
              sortable: "custom",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                (editMode.value && scope.row.id === newObject.value.id)
                  ? (_openBlock(), _createBlock(_unref(ElInput), {
                      key: 0,
                      placeholder: _unref(t)('Common.Name'),
                      id: 'name-input' + scope.$index,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                      modelValue: newObject.value.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newObject.value.name) = $event))
                    }, null, 8, ["placeholder", "id", "modelValue"]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      id: 'name-' + scope.$index
                    }, [
                      _createElementVNode("strong", {
                        id: 'name-label' + scope.$index
                      }, _toDisplayString(scope.row.name), 9, _hoisted_3),
                      (
                  _unref(hasPermission)('CONNECTIONS.LIST.INLINE.EDIT') &&
                  hoverId.value === scope.row.id
                )
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "pencil-span",
                            id: 'inline-edit-icon-' + scope.$index,
                            onClick: _withModifiers(($event: any) => (openEditMode(scope.row)), ["stop"])
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                          ], 8, _hoisted_4))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_2))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.CreationTime'),
              prop: "createdAt",
              sortable: "custom",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(convertDate(scope.row.createdAt)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Connector'),
              prop: "connector",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      class: "logo-step-header",
                      src: `${_unref(ASSETS_BASE_URL)}/${
                    scope.row.connectorSpecId
                  }${_unref(getResolution)(true)}.png`,
                      alt: "logo"
                    }, null, 8, _hoisted_7)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Connection.Authentication'),
              prop: "authType",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                (scope.row.authenticationType)
                  ? (_openBlock(), _createBlock(_unref(ElTag), {
                      key: 0,
                      class: _normalizeClass(scope.row.authenticationType.toLowerCase())
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.authenticationType.toUpperCase()), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Active'),
              prop: "active",
              width: "130px"
            }, {
              default: _withCtx((scope) => [
                (editMode.value && scope.row.id === newObject.value.id)
                  ? (_openBlock(), _createBlock(_unref(ElSwitch), {
                      key: 0,
                      id: 'active-switch-' + scope.$index,
                      modelValue: newObject.value.active,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newObject.value.active) = $event)),
                      "active-color": "#5022a6",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["id", "modelValue"]))
                  : (_openBlock(), _createBlock(_unref(ElSwitch), {
                      key: 1,
                      id: 'active-switch-' + scope.$index,
                      modelValue: scope.row.active,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.active) = $event),
                      disabled: 
                !_unref(hasPermission)('CONNECTIONS.LIST.INLINE.CHANGE_ACTIVE')
              ,
                      "active-color": "#5022a6",
                      onClick: _withModifiers(($event: any) => (changeActiveStatus(scope.row)), ["stop"])
                    }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "disabled", "onClick"]))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              prop: "actions",
              width: "335px"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(ElInput), {
                    modelValue: search.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((search).value = $event)),
                    size: "mini",
                    id: "search-input",
                    class: "oneTeg-search-input max-w-170",
                    onInput: _unref(onSearchInput),
                    placeholder: _unref(t)('Common.TypeToSearch')
                  }, null, 8, ["modelValue", "onInput", "placeholder"]),
                  _createVNode(_unref(ElDivider), {
                    direction: "vertical",
                    class: "v-divider-stretch",
                    "aria-hidden": "true"
                  }),
                  _createElementVNode("div", _hoisted_9, [
                    (_unref(hasPermission)('CONNECTIONS.LIST.CREATE'))
                      ? (_openBlock(), _createBlock(_unref(ElButton), {
                          key: 0,
                          id: "create-button",
                          class: "no-border btn-oneTeg2-table-create btn-labeled",
                          size: "mini",
                          type: "primary",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push('/connections/create')))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, [
                                _createVNode(_component_font_awesome_icon, { icon: "plus" })
                              ]),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)("Connection.CreateConnection")), 1)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_13, [
                  (
                  editMode.value &&
                  newObject.value.id === scope.row.id &&
                  _unref(hasPermission)('CONNECTIONS.LIST.INLINE.EDIT')
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", {
                          class: _normalizeClass({ animateBtn: animate.value })
                        }, [
                          _createVNode(_unref(ElButton), {
                            class: "btn-oneTeg max-w-42-5",
                            id: 'inline-edit-save-' + scope.$index,
                            size: "mini",
                            type: "primary",
                            onClick: _withModifiers(editSelectedConnection, ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "check" })
                            ]),
                            _: 2
                          }, 1032, ["id"]),
                          _createVNode(_unref(ElButton), {
                            class: "btn-oneTeg margin-left-3",
                            id: 'inline-edit-back-' + scope.$index,
                            size: "mini",
                            type: "primary",
                            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (closeEditMode()), ["stop"]))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "times" })
                            ]),
                            _: 2
                          }, 1032, ["id"])
                        ], 2)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_unref(ElDropdown), null, {
                          dropdown: _withCtx(() => [
                            _createVNode(_unref(ElDropdownMenu), null, {
                              default: _withCtx(() => [
                                (_unref(hasPermission)('CONNECTIONS.LIST.EDIT'))
                                  ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                      key: 0,
                                      id: 'edit-button-' + scope.$index,
                                      onClick: _withModifiers(($event: any) => (
                          _unref(router).push('/connections/edit/' + scope.row.id)
                        ), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("Common.Edit")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["id", "onClick"]))
                                  : _createCommentVNode("", true),
                                (_unref(hasPermission)('CONNECTIONS.LIST.REMOVE'))
                                  ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                      key: 1,
                                      id: 'delete-button-' + scope.$index,
                                      onClick: _withModifiers(($event: any) => (removeConnection(scope.row)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("Common.Delete")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["id", "onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(ElButton), {
                              class: "no-border btn-oneTeg show-on-row-hover",
                              size: "mini",
                              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                              id: 'cog-button-' + scope.$index,
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: "cog" })
                              ]),
                              _: 2
                            }, 1032, ["id"])
                          ]),
                          _: 2
                        }, 1024),
                        (scope.row.loading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("img", {
                                src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                                alt: "Loading...",
                                class: "loader-logo-25"
                              }, null, 8, _hoisted_17)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "default-sort", "empty-text", "row-class-name"]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(OneTegPagination, {
            "page-sizes": [10, 25, 50, 100],
            "page-size": perPageConnections.value,
            "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((perPageConnections).value = $event)),
            total: numberOfConnections.value,
            "current-page": currentPageConnections.value,
            "onUpdate:currentPage": _cache[9] || (_cache[9] = ($event: any) => ((currentPageConnections).value = $event)),
            background: true,
            small: true,
            onSizeChange: sizeChanged,
            onCurrentChange: getConnections,
            layout: 'total, sizes, prev, pager, next'
          }, null, 8, ["page-size", "total", "current-page"])
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_19, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_20)
    ], 512), [
      [_vShow, loadingConnections.value]
    ])
  ]))
}
}

})